//Default setting for dropdown popper for react-bootstrap (1.6.6)
import { Matcher } from '../types/rest/dslTypes';

export const DEFAULT_POPPER_CONFIG: any = { strategy: 'fixed' };

export const DROPZONE_ACCEPTABLE_FILES = ['.har', '.json', '.yaml', '.yml', '.zip', '.wsdl'];

export const conditionalMatchers: Matcher[] = [
  Matcher.equals,
  Matcher.equals_insensitive,
  Matcher.contains,
  Matcher.matches,
  Matcher.not_matches,
  Matcher.equals_json,
  Matcher.matches_json,
  Matcher.equals_xml,
  Matcher.matches_xml,
  Matcher.matches_xml_cdata,
  Matcher.greater_than,
  Matcher.less_than,
];
